import { Model } from "@/models/base/model";

export class UserAnswer extends Model {
  name: string;
  url: string;

  constructor(params: any = {}) {
    super(params);
    this.name = "UserAnswer";
    this.url = "";
  }

  // 登録
  async insertData(params: any = {}) {
    this.url = "/cms/api/question";
    return await super.save(params, "POST");
  }
}
